import { publicApi } from "../shared/apis/api";
import { TResponseApi } from "../../vendors/@types/httpApi";
import { InformeEvento } from "../shared/@types/informeEvento";

/**
 * Serviço responsável por consumir os informes/comunicados de evento.
 * A rota é aberta (pública), então utiliza a instância publicApi, que funciona
 * tanto para usuários logados quanto deslogados.
 */
export default class InformeEventoService {
  private readonly rota = "informes-evento";

  public getVigentes(): Promise<TResponseApi<InformeEvento[]>> {
    return publicApi.get(`${this.rota}/vigente`);
  }
}
